import { Box, Image } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

export const Logo = props => {
  const navigate = useNavigate();
  return (
    <Box cursor={'pointer'} onClick={() => navigate('/')} {...props}>
      <Image 
        src="/assets/logo.svg" 
        width={['32', '40']} 
        filter="drop-shadow(0px 2px 4px rgba(0,0,0,0.1))"
      />
    </Box>
  );
};
